import { useMemo } from 'react'
import { ISalesTeam, SalesTeam } from '@user/store/salesTeam'

export function useGetSalesTeamInputLabel(
  salesTeamId: number | 'All' | '',
  salesTeams: ISalesTeam[] | SalesTeam[],
) {
  const label = useMemo(() => {
    const selectedSalesTeam = salesTeams.find((s) => s.id === salesTeamId)

    return selectedSalesTeam
      ? selectedSalesTeam.branchName &&
        selectedSalesTeam.branchName.trim().length > 0
        ? `${selectedSalesTeam.name} - ${selectedSalesTeam.branchName}`
        : `${selectedSalesTeam.name}`
      : salesTeamId === 'All'
      ? 'All Sales Teams'
      : ''
  }, [salesTeamId, salesTeams])

  return label
}
